import { Grid } from 'semantic-ui-react';
import React from 'react';

const InfoGridBox = ({ title, info }) => {
  const InfoType = typeof info;
  return (
    <Grid>
      <Grid.Column width={3}>
        <b>{title}</b>
      </Grid.Column>
      <Grid.Column width={11}>
        {InfoType === 'string' ? <p>{info || '-'}</p> : <p>{info ? `${info}일` : '-'}</p>}
      </Grid.Column>
    </Grid>
  );
};

export default InfoGridBox;
